angular.module('cfn').directive('mapelement', [
  '$compile',
  function($compile) {
    return {
      restrict: 'A',
      replace: false,
      transclude: true,
      scope: { mapelement: '=mapelement' },
      link: function(scope, element, attrs) {
        scope.$watch('mapelement', function(html) {
          element.html(html);
          $compile(element.contents())(scope);
        });
      }
    };
  }
]);
